export const MAX_CHAT_ATTACHMENTS = 5;

export const MAX_CHAT_ATTACHMENT_SIZE_BYTES = 10 * 1024 * 1024;

export const ALLOWED_CHAT_ATTACHMENT_EXTENSIONS = ['png', 'jpg', 'jpeg', 'gif', 'webp', 'pdf', 'docx', 'doc', 'txt', 'log', 'xlsx', 'xls'] as const;

export const CHAT_ATTACHMENT_ACCEPT = ALLOWED_CHAT_ATTACHMENT_EXTENSIONS.map((extension) => `.${extension}`).join(',');

export const isAllowedChatAttachment = (fileName: string): boolean => {
    const extension = fileName.toLowerCase().split('.').pop() ?? '';
    return ALLOWED_CHAT_ATTACHMENT_EXTENSIONS.includes(extension as (typeof ALLOWED_CHAT_ATTACHMENT_EXTENSIONS)[number]);
};

export const splitDroppedFiles = (files: File[]): { efFile: File | null; complementaryFiles: File[] } => {
    const [efFile, ...complementaryFiles] = files;
    return { efFile: efFile ?? null, complementaryFiles };
};
